import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Table, Tag, Menu, Dropdown, Select } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';


import { DatePicker, Space, Button } from 'antd';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Amenities from './Amenities';

const NewAmenities: React.FC = (props:any) => {

  const [data, SetData] = useState([]);





  const { Option } = Select;

  const user = JSON.parse(localStorage.getItem("userobject") || '{}');
  const [AmmenityObject, setState] = useState({

    Name: "",
    Status: "",
  });

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value
    }));



    setState(prevState => ({
      ...prevState,
      userid: user.id
    }));
  };

  function handleChangeSelect(value: any) {
    setState(prevState => ({
      ...prevState,
      Status: value
    }));



  }

  const handleChangecheckbox = (e: any, name: any) => {

    setState(prevState => ({
      ...prevState,
      [name]: e
    }));
  };
  const { name } = useParams<{ name: string; }>();
  const { Column, ColumnGroup } = Table;





  return (

    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              onBack={()=>{props.history.goBack()}}
              title="Add Amenities"

            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="18" style={{ paddingLeft: "40px" }}>
                <IonCard>
                  <IonCardHeader>

                  </IonCardHeader>

                  <IonCardContent>

                    <Space direction="vertical">
                      <p>Name</p>
                      <Input value={AmmenityObject.Name} onChange={handleChange}  name="Name" placeholder="Enter name" />

                      <IonRow>
                        <IonCol>

                        </IonCol>
                        <IonCol>

                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol>
                          <Select defaultValue="Disabled" style={{ width: 120 }}   onChange={handleChangeSelect}>
                            <Option value="Enabled">Enabled</Option>
                            <Option value="Disabled">Disabled</Option>
                          </Select>
                        </IonCol>
                        <IonCol>
                          <Link to="/Amenities">
                            <Button type="primary" onClick={() => {

                              axios({
                                method: 'post',
                                url: 'https://dev.northroom.co.za/api/bizprop/properties/save/ammenity',
                                data: {
                                  Name:AmmenityObject.Name,
                                  Status: AmmenityObject.Status
                                }
                              });


                            }}>Submit</Button>
                          </Link>
                        </IonCol>
                      </IonRow>
                    </Space>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>

        </Space>
      </IonContent>
    </IonPage>

  );
}

export default NewAmenities;